
import React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, Menu, Icon } from 'antd'
import classnames from 'classnames'
import Layout from '../../views/Layout'
import './index.scss'

export default ({ component: Component, ...props }) => (
  <Layout {...props} component={matchProps => (
    <div>
      <SettingsNav {...matchProps} />
      <Component {...matchProps} />
    </div>
  )} />
)

const UserDropdown = ({ className }) => (
  <Dropdown overlay={(
    <Menu>
      <Menu.Item>
        <Link to='/users'>Users List</Link>
      </Menu.Item>
      <Menu.Item>
        <Link to='/roles'>Permission Categories</Link>
      </Menu.Item>
    </Menu>
  )} trigger={['click']}>
    <a className={'ant-dropdown-link ' + className} href='#' >
      Users <Icon type='down' />
    </a>
  </Dropdown>
)

const SettingsNav = ({ match }) => {
  const links = [
    /*{
      to: '/profile',
      text: 'Profile',
      active: true
    },*/
    // {
    //   to: '/pricings',
    //   text: 'Plans'
    // },
    {
      to: '/billing',
      text: 'Billing'
    },

    {
      to: '/users',
      text: 'Users'
    },
    {
      to: '/roles',
      text: 'Permissions'
    },
    {
      to: '/security-credentials',
      text: 'Security Credentials'
    }
    
    /*,
    {
      to: '/users',
      component: UserDropdown
    }*/
  ]

  return (
    <div className='settings-nav'>
      {links.map((link, index) => {
        const className = classnames({
          active: match.path.includes(link.to)
        })
        if (link.component) {
          const { component: Component } = link
          return <Component key={index} className={className} />
        } else {
          return <Link
            key={index}
            to={link.to}
            className={className}>
            {link.text}
          </Link>
        }
      })}
    </div>
  )
}
